export enum MCarouselControlsType {
  Dots = 'dots',
  Numbers = 'numbers',
  /**
   * @deprecated Use {@link MCarouselControlsType.Numbers} instead.
   * Kept for backward compatibility with legacy AEM content.
   */
  Digits = 'digits',
}

export interface MCarouselControlsProps {
  type?: MCarouselControlsType;
  imageOverlay?: boolean;
  totalSlides?: number;
  currentSlide?: number;
  onNext?: () => void;
  onPrev?: () => void;
  className?: string;
  arrows?: boolean;
  /**
   * Keeps boundary arrows enabled for parent carousels that wrap from last to first.
   */
  loop?: boolean;
}
